import React, { useState, useEffect } from 'react';
import { Card, Typography, Row, Col, Spin, message, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import AdminMainLayout from '../AdminMainLayout';
import CustomersTable from '../CustomersTable/CustomersTable';

const { Title, Text } = Typography;

const CompanyDetails = () => {
  const [companyId, setCompanyId] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    // Get company ID from pathname
    const pathParts = window.location.pathname.split('/');
    const idFromPath = pathParts[pathParts.length - 1];
    if (idFromPath && idFromPath !== 'CompanyDetails') {
      setCompanyId(idFromPath);
      fetchCompanyDetails(idFromPath);
    } else {
      message.error('Company ID not found');
      window.location.href = '/admin_customers';
    }
  }, []);

    const fetchCompanyDetails = async (id) => {
    try {
      setLoading(true);
      // This is a dummy API call - replace with actual endpoint when implementing
      const response = await axios.post(ENVIRONMENT.COMPANY_GET_BATCH, {
        company_id: id
      });
      
      if (response.data && response.data.length > 0) {
        setCompanyData(response.data[0]);
      } else {
        message.error('Company not found');
        window.location.href = '/admin_customers';
      }
    } catch (error) {
      console.error('Error fetching company details:', error);
      message.error('Failed to fetch company details');
      window.location.href = '/admin_customers';
    } finally {
      setLoading(false);
    }
   };

  if (loading) {
    return (
      <AdminMainLayout selected="admin_customers">
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
          <div style={{ marginTop: '20px' }}>Loading company details...</div>
        </div>
      </AdminMainLayout>
    );
  }

  if (!companyData) {
    return (
      <AdminMainLayout selected="admin_customers">
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Text>Company not found</Text>
        </div>
      </AdminMainLayout>
    );
  }

  return (
    <AdminMainLayout selected="admin_customers">
      <div style={{ padding: '24px' }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={() => window.location.href = '/admin_customers'}
              style={{ marginBottom: '16px' }}
            >
              Back to Companies
            </Button>
            <Title level={2}>Company Details</Title>
          </Col>
          
          <Col span={24}>
            <Card title="Basic Information" style={{ marginBottom: '24px' }}>
              <Row gutter={[16, 16]} style={{marginTop: '8px'}}>
                <Col span={12}>
                  <Text strong style={{ paddingLeft: '32px' }}>Company ID:</Text>
                  <br />
                  <Text style={{ paddingLeft: '32px' }}>{companyData.company_id}</Text>
                </Col>
                <Col span={12}>
                  <Text strong>Company Name:</Text>
                  <br />
                  <Text>{companyData.company_display_name}</Text>
                </Col>
                <Col span={12}>
                  <Text strong style={{ paddingLeft: '32px' }}>Domain:</Text>
                  <br />
                  <Text style={{ paddingLeft: '32px' }}>{companyData.company_domain}</Text>
                </Col>
                <Col span={12}>
                  <Text strong>Status:</Text>
                  <br />
                  <Text>Active</Text>
                </Col>
              </Row>
            </Card>
          </Col>



          {companyData && (
            <Col span={24}>
              <Card 
                title={`Company Users (${totalUsers})`}
                style={{ marginBottom: '24px' }}
                extra={
                  <Text type="secondary">
                    Showing users for company: {companyData.company_display_name}
                  </Text>
                }
              >
                <CustomersTable 
                  company_id={companyId} 
                  onUserCountChange={setTotalUsers}
                />
              </Card>
            </Col>
          )}
        </Row>
      </div>
    </AdminMainLayout>
  );
};

export default CompanyDetails; 